<template>
  <swiper :options="swiperOptions" ref="cellListSwiper" class="swiper popular-content-list">
    <swiper-slide v-for="(cell, index) in cellList" :key="index">
      <SearchPopularCell
        :cell-info="cell"
        :thumbnail-info="thumbnailInfo"
        :index="index"
      />
    </swiper-slide>
    <div class="swiper-button-prev" slot="button-prev" />
    <div class="swiper-button-next" slot="button-next" />
    <slot name="banner-wrapper" />
  </swiper>
</template>
<script>
  import _ from 'lodash'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import SearchPopularCell from '@/components/search/view/SearchPopularCell'

  export default {
    name: 'SearchPopularCellList',
    components: {
      SearchPopularCell,
      swiper,
      swiperSlide
    },
    props: {
      cellList: {
        type: Array
      }
    },
    data () {
      return {
        thumbnailInfo: {
          width: 360,
          height: 203,
          containerSize: 327,
          placeholderImage: require('../../../assets/images/common/img_default_thum_2.svg')
        },
        swiperOptions: {
          width: 1240,
          height: 50,
          spaceBetween: 10,
          slidesPerView: 5,
          slidesPerGroup: 5,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          observer: true
        }
      }
    },
    computed: {
      swiper () {
        return this.$refs.cellListSwiper.swiper
      }
    },
    beforeDestroy () {
      const destroyFn = _.get(this.$refs, ['cellListSwiper.$destroy'], function () {})
      destroyFn()
    }
  }
</script>
